export default __webpack_public_path__ + "static/media/chair.e045ea0f.png";